import React, { useCallback } from 'react'
import { formatCurrency } from 'Utils'
import { WhatsappIcon } from '../../assets/svgs/hiFive/index'

const ShareBtnContainer = ({ referralLink, signupReward, rewardAmount, referralLinkEndStr }) => {
  const text = `Hey,\nDid you know you can earn ${formatCurrency(signupReward)} by signing up on Cleartrip with my referral? 
\nPsst..I get ${formatCurrency(rewardAmount)} off on my next booking too. It takes two to trip 😉 
\nSign up before ${referralLinkEndStr} or you miss the bus ⏲️ 
\nJust click here: ${referralLink}`

  const sendWhatsapp = useCallback(() => {
    const whatsappUrl = `https://web.whatsapp.com/send?text=${encodeURIComponent(text)}`
    // Open a new window/tab with the WhatsApp Web URL
    window.open(whatsappUrl, '_blank')
  }, [text])

  return (
    <div>

      <div
        onClick={sendWhatsapp}
        className="bc-transparent bg-neutral-900 box-border br-4 br-8-imp
        hover:bg-neutral-900
      bs-solid button bw-1 c-auto c-pointer c-white flex flex-center flex-middle fs-4 fw-600 h-10 hover:td-none lh-solid pl-0 pr-0 px-5 px-8 py-2
      t-all ta-c td-500 tp-color w-100p"
      >
        <WhatsappIcon width="100" />
        <span className="pl-2 fw-600 fs-14">Invite via WhatsApp</span>
      </div>

    </div>
  )
}

export default ShareBtnContainer
